import axios from 'axios';
import moment from 'moment';

const url = require("../client_config/config").url;

export default {
    data() {
        return {
            documentCounter: 0,
        }
    },

    methods: {
        //async renameFileHelper: function(files, userName, formName) {
        async renameFileHelper(files, userName, formName, date = new Date(), customDate = false) {

            let dateString;

            if(customDate){
                dateString = date.toLowerCase();
            }else{
                dateString = moment(date).format('MMDDYYYY');
            }

            let renamedFiles = [];
            let fileName = "";

            if (files.length === undefined) {

                let file = files;

                let ext = file.name.split(".").pop();
                let splitName = userName.split(" ");

                if (splitName.length === 1) {
                    fileName = `${splitName[0].toLowerCase()}-${dateString}-${formName}`
                } else {
                    fileName = `${splitName[0].toLowerCase()}${splitName[1]}-${dateString}-${formName}`
                }

                await this.getDocumentIncrement(fileName, 1);

                renamedFiles = new File([file], `${fileName}-${this.documentCounter}.${ext}`, {
                    type: file.type,
                })

            } else {
                let counter = 1;
                for (let i = 0; i < files.length; i++) {
                    let file = files[i];

                    let ext = file.name.split(".").pop();
                    let splitName = userName.split(" ");

                    if (splitName.length === 1) {
                        fileName = `${splitName[0].toLowerCase()}-${dateString}-${formName}`
                    } else {
                        fileName = `${splitName[0].toLowerCase()}${splitName[1]}-${dateString}-${formName}`
                    }

                    await this.getDocumentIncrement(fileName, counter++);

                    renamedFiles.push(
                        new File([file], `${fileName}-${this.documentCounter}.${ext}`, {
                            type: file.type,
                        })
                    );
                }
            }

            return renamedFiles
        },

        async getDocumentIncrement(filename, counter) {
            filename = encodeURIComponent(filename);
            return axios.get(`${url}/documents/findDuplicate/${filename}`).then(res => {
                this.documentCounter = res.data.documents + counter;
            });
        },
    }
}
